module.exports = __webpack_public_path__ + "img/qj.390bdd3b.png";